import type { SvgComponent } from '@/types/SvgComponent';

export const SparkleSlashIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M4.5 3.75L19.5 20.25"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1823 13.6479L18.4735 13.1721L19.7646 12.6963C19.907 12.6438 20.0299 12.5488 20.1167 12.4243C20.2035 12.2997 20.25 12.1516 20.25 11.9998C20.25 11.848 20.2035 11.6998 20.1167 11.5753C20.0299 11.4507 19.907 11.3558 19.7646 11.3032L14.5999 9.40007L12.6968 4.23539C12.6442 4.09298 12.5493 3.9701 12.4247 3.88332C12.3002 3.79653 12.1521 3.75 12.0002 3.75C11.8484 3.75 11.7003 3.79653 11.5757 3.88332C11.4512 3.9701 11.3563 4.09298 11.3037 4.23539L10.8279 5.52656L10.59 6.17214L10.4711 6.49494"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.40007 9.40015L4.23539 11.3033C4.09298 11.3558 3.9701 11.4508 3.88332 11.5753C3.79653 11.6999 3.75 11.848 3.75 11.9998C3.75 12.1516 3.79653 12.2998 3.88332 12.4243C3.9701 12.5489 4.09298 12.6438 4.23539 12.6964L9.40007 14.5995L11.3032 19.7642C11.3558 19.9066 11.4507 20.0295 11.5753 20.1163C11.6998 20.2031 11.848 20.2496 11.9998 20.2496C12.1516 20.2496 12.2997 20.2031 12.4243 20.1163C12.5488 20.0295 12.6438 19.9066 12.6963 19.7642L13.6479 17.1819L14.1237 15.8907L14.3616 15.2451"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
